import { render } from "./LockedFeature.vue?vue&type=template&id=1228f008"
import script from "./LockedFeature.vue?vue&type=script&lang=js"
export * from "./LockedFeature.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__